import { useEffect } from 'react'
import useHelpContext from './useHelpContext'

export default function useHelpPopup(popupSlug, active = true, delay = 2000) {
  const { addPopup, removePopup } = useHelpContext()

  useEffect(() => {
    if (!active) return

    if (delay) {
      setTimeout(() => addPopup(popupSlug), delay)
    } else {
      addPopup(popupSlug)
    }

    return () => removePopup(popupSlug)
  }, [popupSlug, active])
}
